<div class="two-option-modal" [ngClass]="{'light-theme': !option.darkTheme,'dark-theme': option.darkTheme}">
    <div class="close-modal" (click)="activeModal.close('')">
        <img appImageSelector alt="mt-image" imageType="icon" [imageKey]="option.darkTheme ? 'close' : 'close-gray'">
    </div>

    <div class="title">
        {{option.title | lang }}
    </div>

    <div class="img">
        <img appImageSelector alt="mt-image" [imageType]="option.imageType" [imageKey]="option.imageKey" width="70">
    </div>

    <div class="message" *ngIf="option?.message">
        <span>{{option.message | lang: option.messageParam ? option.messageParam : ''}}</span> <br>
        <span *ngIf="option.emailLogin">
            <img class="img-contact" alt="mt-contact" appImageSelector imageType="icon" imageKey="mail-contacto">{{ option.emailLogin }} </span>
    </div>

    <div class="button-group flex-row">
        <app-button *ngIf="option?.cancelButtonText" class="cancel shadowed rounded" [text]="option.cancelButtonText" (clickHandler)="activeModal.close('')"></app-button>

        <app-button-state *ngIf="option?.actionButtonText" class="action rounded shadowed ml-60" [text]="option.actionButtonText"
            (clickHandler)="logout()"></app-button-state>
    </div>

    <div *ngIf="errorMsg" class="d-flex justify-content-center error-msg">
      <app-server-error-message [errorMessage]="errorMsg"></app-server-error-message>
  </div>
</div>